export default __webpack_public_path__ + "static/media/cl.178b4ca5.svg";